const FEEDBACK_CONTENT = {
  QUESTION: 'Heeft dit antwoord je geholpen?',
  CONFIRMATION: 'Bedankt voor je feedback!',
  BUTTON_YES: 'Ja',
  BUTTON_NO: 'Nee',
};

export { FEEDBACK_CONTENT as default };
